require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-regular-expressions-using-the-test-method.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-regular-expressions-using-the-test-method");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-regular-expressions-using-the-test-method!./.cache/json/javascript-algorithms-and-data-structures-regular-expressions-using-the-test-method.json
// module id = 2508
// module chunks = 231608221292675